
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class TextoRotulado extends Vue {
  @Prop()
  rotulo!: string;
}
